// FAQPage.js
// adapated from OverallStudyResultsPage.js

import React, { Component } from 'react';
import Modal from '../components/Modal.js';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import helpers from '../util/helpers';

class FAQPage extends Component {
    constructor(props) {
      super(props);
      this.numFAQs = props.intl.messages[`common_questions.number_questions`];
      this.state = {
        modals: [false, false, false, false],
        expanded: new Array(this.numFAQs).fill(false),
      };

    }

    render() {

      let common_questions = []
      let self = this;
      for (let i = 0; i < this.numFAQs; i++) {
        let expanded = this.state.expanded[i]
        let toggleFunction = function() {
          let expanded = self.state.expanded;
          if (!expanded[i]) {
            helpers.eventLog(`faq: expand question - ${i}`)
          } else {
            helpers.eventLog(`faq: collapse question - ${i}`)
          }
          expanded[i] = !expanded[i];
          self.setState({
            expanded: expanded
          })
        };

        let q_props = {
          key: 'title'+(i+1),
          className: "question expanded-"+expanded,
          onClick: toggleFunction,
        }
        let q_text_id = `common_questions.q${i+1}.title`
        let a_props = {
          key: 'content'+(i+1),
          className: "answer expanded-"+expanded,
        }
        let a_text_id = `common_questions.q${i+1}.content`

        let q = (<div {...q_props}>
                  <div className={`chevron-faq ${expanded}`}><span/></div>
                  <span className="q-text"><FormattedMessage id={q_text_id} /></span>
                </div>)
        common_questions.push(q)

        if (this.state.expanded[i]) {
          let a = (<div {...a_props}><span className="a-text"><FormattedHTMLMessage id={a_text_id} /></span></div>)
          common_questions.push(a)
        }

      }

      return (
        <div className="page common-questions">
          <h2>
          <FormattedMessage id='common_questions.title' defaultMessage='Common Questions' />
          </h2>

          <FormattedHTMLMessage id='common_questions.contact' defaultMessage='test' />

          {common_questions}
        </div>

      )
    }
} // end FAQPage

export default injectIntl(FAQPage);



// WEBPACK FOOTER //
// ./src/pages/FAQPage.js